// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledSVG, StyledPara, StyledAmenityContainer } from './Amenity.styles';

class Amenity extends Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  };

  static defaultProps = {};

  render() {
    const { icon, title } = this.props;
    return (
      <StyledAmenityContainer>
        <StyledSVG selectedIcon={icon} width="16px" height="16px" />
        <StyledPara tagName="span">{title}</StyledPara>
      </StyledAmenityContainer>
    );
  }
}

export default Amenity;
